<template>
    <mobileNav v-if="isMobile"></mobileNav>
    <headerNav v-else></headerNav>

    <cursor v-if="!isMobile"></cursor>
    <router-view/>
</template>

<script>
import { defineComponent, onMounted, ref, watch } from 'vue';
import headerNav from './components/header_nav.vue';
import mobileNav from './components/mobile_nav.vue';
import cursor from './components/new_cursor.vue';
export default defineComponent({
  components: { headerNav, cursor, mobileNav },
  setup() {
    const isMobile = function () {
      // console.log('navigator.userAgent', navigator.userAgent)
      const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return screenWidth < 768 && flag  
    }();
    onMounted(() => {
      const _view = document.querySelector("meta[name=viewport]");
      const cWidth = document.documentElement.clientWidth;
      const pageWidth = 360;
      let _pixWidth = cWidth;
      Math.ceil(pageWidth / window.devicePixelRatio) >= pageWidth && (_pixWidth = Math.ceil(window.screen.width / window.devicePixelRatio));
      const _scale = _pixWidth / pageWidth;
      const _str = `width=${pageWidth}, initial-scale=${_scale}, maximum-scale=${_scale},minimum-scale=${_scale}, user-scalable=no`
      _view.setAttribute("content", _str);

      getLang()
      setPageTitle()
    })
    
    const lang = ref('zh')

    const getLang = () => {
      const localLang = localStorage.getItem('lang')
      lang.value = localLang === 'en' ? 'en' : 'zh'
    }

    const setPageTitle = () => {
      document.title = lang.value === 'en' ? 'The Wandering Earth: The Last Full Moon' : '流浪地球：望日'
    }


watch(lang, () => {
  setPageTitle()
})

    return {
      isMobile
    }
  }
})
</script>

<style lang="less">
*{
  margin: 0;
  padding: 0;
}
a, div, img {
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
html, body, #app{
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  cursor: none;
  //   font-size: 100px;
}
::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

::-webkit-scrollbar-thumb {
  background-color: #8a8a8a;
  border-radius: 3px;
}

</style>
